module.exports = __webpack_public_path__ + "static/media/Portrait-10196.10bdacc2.jpg";